import { useLang } from "../context/LanguageContext";
import { useForm } from "../context/FormContext";

interface Props {
  isLastStep?: boolean;
  canContinue?: boolean;
  onContinue?: () => boolean | Promise<boolean>;
  onBack?: () => void;
  continueLoading?: boolean;
}

export default function FormNavigation({
  isLastStep = false,
  canContinue = true,
  onContinue,
  onBack,
  continueLoading = false,
}: Props) {
  const { t } = useLang();
  const { currentStep, goNext, goBack } = useForm();
  const primaryDisabled = continueLoading;

  const handlePrimary = async () => {
    if (primaryDisabled) return;
    if (onContinue) {
      const ok = await onContinue();
      if (!ok) return;
    }
    goNext();
  };

  return (
    <div className="max-w-[480px] mx-auto px-4 pb-24 sm:pb-10 pt-6">
      <div className="flex flex-col gap-3">
        <button
          onClick={handlePrimary}
          disabled={primaryDisabled}
          className="w-full h-12 flex items-center justify-center gap-2 text-[15px] font-semibold rounded-xl transition-colors whitespace-nowrap disabled:cursor-not-allowed bg-emerald-600 text-white cursor-pointer hover:bg-emerald-700 disabled:bg-slate-200 disabled:text-slate-500"
        >
          {continueLoading ? t("header.saving") : isLastStep ? t("nav.submit") : t("nav.continue")}
        </button>

        {currentStep > 1 && (
          <button
            onClick={onBack || goBack}
            className="w-full h-12 flex items-center justify-center gap-2 text-slate-600 text-[15px] font-medium rounded-xl border border-slate-200 cursor-pointer hover:bg-slate-50 transition-colors whitespace-nowrap"
          >
            {t("nav.back")}
          </button>
        )}
      </div>
    </div>
  );
}
